module.exports = __webpack_public_path__ + "img/banner-principal.708b0aee.svg";